import styled from 'styled-components';

const StyledHomePage = styled.div`
  width: 100%;
  height: 100vh;
  background-color: black;

  .fr-home-page {
    width: 100%;
    height: calc(100vh - 100px);
    max-width: 1400px;
    padding-bottom: 100px;
    position: relative;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    flex-direction: column;

    &__loading-container {
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 32px;
    }

    &__cards {
      width: 100%;
      flex-wrap: wrap;
      align-items: flex-start;
      align-content: flex-start;
      gap: 16px;
      overflow: auto;
      max-height: calc(100vh - 150px);
    }

    &__player {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
`;

export default StyledHomePage;
